import axios from '@/utils/miniAxios'
const api = {
    getPicCode: '/commons/captcha',
    getSmsCaptcha: '/commons/sendSms',
    login: '/api/users/register',
    getInfo: '/api/users',
    getProblems: '/api/commonproblem',
    getHelp: '/commons/file/download',
    checkPhone: '/api/users/phone/exist',
    getActivityRecord: '/api/opens/activity/record',
    getActivityList: '/api/opens/activity',
    getRecordList: '/api/opens/activity/record',
    getInviteList: '/api/users/inviteList'
}

// 获取邀请码
export function getUserInfo (id) {
    return new Promise((resolve, reject) => {
        axios.get(`api/opens/userinfo/${id}`)
            .then(response => {
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

// 核销优惠券二维码详情
export function getSureCouponDetail (params) {
    return new Promise((resolve, reject) => {
        axios.get('/company/activity/getCouponByRecordId', { params })
            .then(response => {
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

// 核销
export function sureWrite (params) {
    return new Promise((resolve, reject) => {
        axios.put('/company/activity/useProduct', { ...params })
            .then(response => {
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            })
    })
}
export function editAddress (id,params) {
    return new Promise((resolve, reject) => {
        axios.put(`/api/user/addresses/${id}`,params)
            .then(response => {
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            })
    })
}
// 新增地址
export function addAddress (params) {
    return new Promise((resolve, reject) => {
        axios.post('/api/user/addresses', { ...params })
            .then(response => {
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            })
    })
}
export function getAddAddressList (params) {
    return new Promise((resolve, reject) => {
        axios.get('/api/user/addresses', { ...params })
            .then(response => {
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            })
    })
}
// 邀请列表
export function getInviteList (params) {
    return new Promise((resolve, reject) => {
        axios.get(api.getInviteList, { params })
            .then(response => {
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

// 我的奖品
export function getRecordList (params) {
    return new Promise((resolve, reject) => {
        axios.get(api.getRecordList, { params })
            .then(response => {
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

// 抽奖
export function luckDraw (id, params) {
    return new Promise((resolve, reject) => {
        axios.post(`/api/activity/luckDraw/${id}`, { ...params })
            .then(response => {
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

// 获取活动详情
export function getActivityDetail (id) {
    return new Promise((resolve, reject) => {
        axios.get(`/api/opens/activity/${id}`)
            .then(response => {
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

// 查询活动列表
export function getActivityList (params) {
    return new Promise((resolve, reject) => {
        axios.get(api.getActivityList, { params })
            .then(response => {
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

// 邀请好友页面参与活动记录
export function getActivityRecord (params) {
    return new Promise((resolve, reject) => {
        axios.get(api.getActivityRecord, { params })
            .then(response => {
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

// 邀请好友页面轮播图片
export function getActivityImg (id) {
    return new Promise((resolve, reject) => {
        axios.get(`/api/opens/activity/${id}`)
            .then(response => {
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

// 邀请好友页面获取用户昵称
export function getUserName (id) {
    return new Promise((resolve, reject) => {
        axios.get(`/api/opens/userinfo/${id}`)
            .then(response => {
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

/**
    * 获取常见问题列表
    * @returns {Promise<any>}
*/
export function getProblems (params) {
    return new Promise((resolve, reject) => {
        axios.get(api.getProblems, { params })
            .then(response => {
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            })
    })
}
export function checkPhone (params) {
    return new Promise((resolve, reject) => {
        axios.get(api.checkPhone, { params })
            .then(response => {
                resolve(response.data)
            })
            .catch((error) => {
                reject(error)
            })
    })
}
export function downFile (path) {
    return new Promise((resolve, reject) => {
        axios.get(api.getHelp, { params: { path }, responseType: 'arraybuffer' }).then(res => {
            resolve(res)
        }).catch(err => {
            reject(err.msg || '未知错误')
        })
    })
}

export function getProblemById (id) {
    return new Promise((resolve, reject) => {
        axios.get(api.getProblems + '/' + id)
            .then(response => {
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            })
    })
}
/**
 * 获取用户信息
 * @returns {Promise<any>}
 */
export function getInfo () {
    return new Promise((resolve, reject) => {
        axios.get(api.getInfo)
            .then(response => {
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            })
    })
}
/**
 * 获取图片验证码
 * @returns {Promise<any>}
 */
export function fetchCode () {
    return new Promise((resolve, reject) => {
        axios.get(api.getPicCode, { responseType: 'arraybuffer' })
            .then(response => {
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            })
    })
}
/**
 * auth
 * @returns {Promise<any>}
 */
export function getSmsCaptcha (params) {
    return new Promise((resolve, reject) => {
        axios.post(api.getSmsCaptcha, { ...params })
            .then(response => {
                resolve(response.data)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

/**
 * login
 * @returns {Promise<any>}
 */
export function fetchLogin (params) {
    return new Promise((resolve, reject) => {
        axios.post(api.login, { ...params })
            .then(response => {
                resolve(response.data)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

// 现金奖励，立即兑换
export function redeemNow (params) {
    return new Promise((resolve, reject) => {
        axios.put('/api/activity/useProduct', { ...params })
            .then(response => {
                resolve(response.data)
            })
            .catch((error) => {
                reject(error)
            })
    })
}
